<body class="app">
  <header class="app-header navbar"
  style="width: 100%; height: 30%;"
  >
    <!-- Header content here -->
  </header>

<div class="app-body">
    <main class="main d-flex align-items-center">
      <div class="container">
        <div class="row">
          <div class="col-md-8 mx-auto">
            <div class="card-group">
              <div class="card p-2">
                <div class="card-body">
                  <div class="col-md-12 col-g-12">
  
                    <div class="login-box">
                        <div class="login-body">
                            <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
                                <div class="input-group mb-2">
                                    <h2>Recuperar contraseña</h2>
                                </div>
  
                                <div class="input-group mb-1">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fa fa-at"></i></span>
                                    </div>
                                    <input type="email" class="form-control" placeholder="Email"
                                    formControlName="email">
                                </div>
                                <div class="input-group mb-0">
                                    <p>Por favor ingrese su dirección de correo electrónico válida.</p>
                                </div>
                                <div class="input-group mb-0" *ngIf="submited">
                                    <p class="text-info"><strong>Su contraseña fue enviada a su
                                            correo</strong></p>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <button pButton label="Restaurar Contraseña" [disabled]="!resetForm.valid" type="submit"></button>
                                    </div>
                                    <div class="col-6 text-right">
                                        <span class="light">
                                            ¿Ya tienes usuario y contraseña?
                                            <a [routerLink]="['/login']">Iniciar Sesion</a>
                                        </span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
  
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
  
  <footer class="app-footer">
    <!-- Footer content here -->
  </footer>
</body>